/* 订单计划 */
<template>
  <div id="orderPlan" class="q-pa-md">
    <q-form id="queryForm" :model="queryForm" @submit="query" @reset="reset">
      <div class="row q-col-gutter-md justify-center">
        <div class="col-md-3 col-11">
          <q-select filled v-model="queryForm['customer.customerNo']" :options="customerList"
            option-label="customerName" option-value="customerNo" emit-value map-options label="客户" dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-select filled v-model="queryForm['type.id']" :options="yarnList" option-label="typeName" option-value="id"
            emit-value map-options label="纱支类型" dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-input v-model="queryForm.orderNo" label="订单编号" filled dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-input v-model="queryForm.cylinderNo" label="缸号" filled dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-input v-model="queryForm.color" label="颜色" filled dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-input v-model="queryForm.colorNo" label="色号" filled dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-select outlined v-model="queryForm['supplier.id']" :options="supplierList" option-label="supplierName"
            option-value="id" emit-value map-options label="加工工厂" filled dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-btn label="查询" type="submit" color="primary" />
          <q-btn label="重置" type="reset" color="primary" flat class="q-ml-sm" />
        </div>
      </div>
    </q-form>

    <q-table ref="mytable" title="订单计划" :data="tableData.list" :columns="columns" row-key="id"
      :pagination.sync="pagination" :loading="loading" @request="request" binary-state-sort separator="cell"
      :rows-per-page-options="[10, 20, 50, 0]">
      <template v-slot:body-cell-opt="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-btn round color="primary" size="xs" title="二维码" icon="qr_code_2"
              @click="toQRcode(props.rowIndex, props.row)" />
            <q-btn round color="primary" size="xs" title="标签" icon="print"
              @click="toPrintBucketLabe(props.rowIndex, props.row)" />
          </div>
        </q-td>
      </template>
      <template v-slot:bottom-row>
        <q-tr v-if="tableData.sumMap">
          <q-td align="center"> 合计 </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.SUM_PRODUCT_WEIGHT).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.SUM_NET_WEIGHT).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center">
            {{
              numbro(
                (tableData.sumMap.SUM_PRODUCT_WEIGHT -
                  tableData.sumMap.SUM_NET_WEIGHT) /
                tableData.sumMap.SUM_PRODUCT_WEIGHT
              ).format({
                thousandSeparated: true,
                output: "percent",
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center"> N/A </q-td>
        </q-tr>
      </template>
    </q-table>

    <!-- 订单计划
    
    <el-button id="printBucketLabe" type="primary" @click="toPrintBucketLabe">打印标签</el-button>-->
  </div>
</template>

<style scoped>
@import url("../styles/print.css");

table {
  float: left;
  border: 0;
}
</style>

<script>
import { listAll } from "@/api/erp/customer.js";
import { list as listYarn } from "@/api/erp/yarn.js";
import { list as listSupplier } from "@/api/erp/supplier"
import { list } from "@/api/erp/order/orderPlan";
import numbro from "numbro";
export default {
  components: {},
  data() {
    return {
      numbro,
      customerList: [],
      supplierList: [],
      yarnList: [],
      queryForm: { pageNum: 1, pageSize: 10 },
      tableData: {},
      loading: false,
      pagination: {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },
      columns: [
        {
          name: "customerName",
          align: "center",
          label: "客户",
          field: (row) => row.customer.customerShortName,
        },
        {
          name: "orderNo",
          align: "center",
          label: "订单编号",
          field: "orderNo",
        },
        {
          name: "orderDate",
          align: "center",
          label: "订单日期",
          field: (row) => row.orderInfo.orderDate,
        },
        {
          name: "productName",
          align: "center",
          label: "纱支类型",
          field: (row) => (row.type ? row.type.typeName : ""),
        },
        {
          name: "yarn",
          align: "center",
          label: "纱支原料",
          field: "yarn",
        },
        {
          name: "color",
          align: "center",
          label: "颜色",
          field: "color",
        },
        {
          name: "colorNo",
          align: "center",
          label: "色号",
          field: "colorNo",
        },
        {
          name: "cylinderNo",
          align: "center",
          label: "缸号",
          field: "cylinderNo",
        },
        {
          name: "productWeight",
          align: "center",
          label: "投染数",
          field: "productWeight",
        },
        {
          name: "netWeight",
          align: "center",
          label: "净重",
          field: "netWeight",
        },
        {
          name: "wastage",
          align: "center",
          label: "损耗",
          field: (row) => this.wastage(row),
          sortable: true,
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
    };
  },
  methods: {
    toPrintBucketLabe(indx, row) {
      let query = {
        id: row.id,
        yarn: row.yarn,
        color: row.color + row.colorNo,
        batchNo: row.cylinderNo,
      };
      this.$router.push({ path: "/order/plan/bucketLabelPrint", query: query });
    },
    toQRcode(index, row) {
      this.$router.push({
        path: "/order/qrcode",
        query: { scene: `orderNo=${row.orderNo}`, page: "pages/mine/order/detail" },
      });
    },
    listCustomer() {
      var self = this;
      listAll().then((response) => {
        self.customerList = response.data.data;
      });
    },
    listYarn() {
      var self = this;
      listYarn().then((response) => {
        self.yarnList = response.data.data;
      });
    },
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    reset() {
      this.queryForm = {};
      this.pagination = {
        sortBy: "desc",
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      };
      this.query();
    },
    request(props) {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      var self = this;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      list(self.queryForm).then(function (response) {
        self.tableData = response.data.data;
        self.pagination.rowsNumber = self.tableData.total;
        // don't forget to update local pagination object
        self.pagination.page = page;
        self.pagination.rowsPerPage = rowsPerPage;
        self.pagination.sortBy = sortBy;
        self.pagination.descending = descending;
        // ...and turn of loading indicator
        self.loading = false;
      });
    },
    wastage(row) {
      if (row.productWeight != null && row.netWeight != null) {
        return numbro(
          (row.productWeight - row.netWeight) / row.productWeight
        ).format({
          thousandSeparated: true,
          output: "percent",
          mantissa: 2,
        });
      }
    },
  },
  mounted() {
    this.listCustomer();
    this.listYarn();
    this.query();
    listSupplier().then((response) => {
      this.supplierList = response.data.data.list;
    });
  },
};
</script>

<style scoped>
#addBtn {
  float: right;
}

#queryForm {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
